<template>
  <div>
    <PartnerRegistrationFormStep1
      :initial-values="initialValues"
      @submit="handleSubmit"
      @update:form-data="handleFormDataUpdate"
    />
  </div>
</template>

<script setup lang="ts">
import type { PartnerRegistrationFormData } from '~/components/partner/PartnerRegistrationFormStep1.vue'
import { usePartnerRegistrationStore } from '~~/stores/partnerRegistration'

definePageMeta({
  layout: 'minimal-dark',
})

useSeoMeta({
  robots: 'noindex, follow',
})

const { goToNextStep } = usePartnerRegistration()
const store = usePartnerRegistrationStore()
const { formData } = storeToRefs(store)

// Map store data to form field names
const initialValues = computed<Partial<PartnerRegistrationFormData>>(() => {
  const data = formData.value
  // Reconstruct business_address from address components if available
  let businessAddress = ''
  if (data.street && data.street_number) {
    businessAddress = `${data.street} ${data.street_number}`
    if (data.zipcode && data.locality) {
      businessAddress += `, ${data.zipcode} ${data.locality}`
    }
  }

  return {
    business_name: data.legal_name || '',
    business_address: businessAddress || '',
    phone_number: data.phone || '',
    website_instagram: data.website || '',
    business_size: data.business_size || '',
    annual_revenue_range: data.annual_revenue || '',
    referral: data.referral || '',
    referral_detail: data.referral_detail || '',
    language: data.language || '',
  }
})

const handleSubmit = (_formData: PartnerRegistrationFormData) => {
  // Form data is already saved to store via watcher in component
  // Navigate to next step
  goToNextStep()
}

const handleFormDataUpdate = (_formData: PartnerRegistrationFormData) => {
  // Form data is already saved to store via watcher in component
}

onMounted(() => {
  sendPartnerRegistration(1)
})
</script>
